// extracted by mini-css-extract-plugin
export default {"centeredInPage":"CenteredInPageCircularProgress_centeredInPage__2ZBkK"};